import { render, staticRenderFns } from "./AppCursor.vue?vue&type=template&id=5c6bf917&scoped=true&"
import script from "./AppCursor.vue?vue&type=script&lang=js&"
export * from "./AppCursor.vue?vue&type=script&lang=js&"
import style0 from "./AppCursor.vue?vue&type=style&index=0&id=5c6bf917&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6bf917",
  null
  
)

export default component.exports